(function ($) {
  $(function () {
    $('.product__accordion.accordion summary').click(function () {
      if ($(this).attr('aria-expanded') == 'true') {
        $(this).find('.toggle_btn').addClass('on');
      } else {
        $(this).find('.toggle_btn').removeClass('on');
      }
    });

    if ($('.product__accordion').length > 0) {
      $('.product__accordion').each(function () {
        const thisRel = $(this).attr('rel') || '';
        const $content = $(this).find('div.accordion__content');

        // "Pair with"처럼 상품 리스트(pill)를 렌더링하는 탭은
        // 문장 분리 대상에서 제외해야 링크(<a>)가 보존됩니다.
        if (thisRel.includes('Pair with') || $content.find('.pair-with__list').length) {
          return;
        }

        const text = $content.text().trim();
        const parts = text
          .split('.')
          .map((s) => s.trim())
          .filter(Boolean);
        const wrapped = parts.map((s) => `<span>${s}</span>`).join('');
        $content.html(wrapped);

        if (thisRel.includes('If You')) {
          $content.find('span').addClass('if_you');
        } else if (thisRel.includes('Best Times')) {
          $content
            .find('span')
            .prepend(
              '<i class="chk"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/check_circle.svg?v=1760347672"></i>'
            )
            .addClass('best_times');
        } else if (thisRel.includes('How To Use')) {
          $content.find('span').addClass('how_to_use');
          $('.how_to_use').each(function () {
            $(this).prepend('<i>Step 0' + ($(this).index() + 1) + '</i>');
          });
        } else if (thisRel.includes('Explained')) {
          $(this).addClass('exp');
        } else if (thisRel.includes('Usage')) {
          $(this).addClass('usage');
        }
      });
    }
  });
})(jQuery);
